import React, { Fragment, useEffect } from "react";
import "./TabelaEstatisticas.css";
import { useProfile } from "../../contexts/ProfileContext.tsx";

function TabelaEstatisticas(props) {
	const meses = Object.keys(props.dados[0].embarquesMes);

	const { contextoEmbarque } = useProfile();

	useEffect(() => {
		if (
			props.dados &&
			props.dados.length > 0 &&
			props.dados[0] &&
			props.dados[0].idEmbarque
		) {
			const tableWrapper = document.getElementById("tableWrapper");
			if (
				tableWrapper &&
				window.location.href.endsWith("embarque") &&
				contextoEmbarque !== "templateEmbarque"
			) {
				tableWrapper.scrollTop = tableWrapper.scrollHeight;
			}
		}
	}, []);

	return (
		<div className="outer-wrapper-terceiros">
			<div className="table-wrapper-terceiros" id="tableWrapper">
				<p style={{ textAlign: "center", marginBottom: 10 }}>Relatorio</p>
				<table className="tabela-terceiros">
					<thead>
						<tr>
							<th
								onClick={() => props.buscarSearch("frota")}
								className="th-terceiros"
							>
								Frota
							</th>
							<th
								onClick={() => props.buscarSearch("proprietario")}
								className="th-terceiros"
							>
								Proprietário
							</th>
							{meses.map((mes) => (
								<th
									onClick={() => props.setMesSelecionado(mes)}
									className="th-terceiros"
									key={mes}
								>
									{mes}
								</th>
							))}
							<th
								onClick={() => props.buscarSearch("media")}
								className="th-terceiros"
							>
								Média
							</th>
							<th
								onClick={() => props.buscarSearch("total")}
								className="th-terceiros"
							>
								Total
							</th>
						</tr>
					</thead>
					<tbody>
						{props.dados.map((linha, index) => (
							<Fragment key={linha.idEmbarque || index}>
								<tr className="tr-hover" key={index}>
									<td className="td-terceiros">{linha.frota}</td>
									<td className="td-terceiros">{linha.proprietario}</td>
									{meses.map((mes) => (
										<td className="td-terceiros" key={mes}>
											{linha.embarquesMes[mes]}
										</td>
									))}
									<td className="td-terceiros">{linha.media}</td>
									<td className="td-terceiros">{linha.total}</td>
								</tr>
							</Fragment>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default TabelaEstatisticas;
